import React, { Component } from 'react';
import styles from './api-access-settings.module.sass';
import { Table, Button } from 'antd';
import { DeleteOutlined, EditOutlined, CopyOutlined } from '@ant-design/icons';
import { STATUS } from '../../../../redux/constants';
import DetailsModal from './DetailsModal';
import { confirmDelete } from '../../../../shared-components/DeleteConfirm';
import moment from 'moment-timezone';
import {
  infoNotification,
  showNotification,
} from '../../../../shared-components/Notifications';
import { ColumnTitle } from '../../../../shared-components/ColumnTitle';

export class APIAccessSettings extends Component {
  state = {
    showModal: false,
    selectedAPIKey: null,
    searchQuery: '',
  };
  componentDidMount() {
    const { status } = this.props;
    if (status === STATUS.IDLE) {
      this.props.loadAPIAccess();
    }
  }

  handleCreateClick = () => {
    this.setState({ showModal: true });
  };

  handleModalClose = () => {
    this.setState({ showModal: false, selectedAPIKey: null });
  };

  handleSubmit = (data) => {
    const { selectedAPIKey } = this.state;

    if (data.expires_at) {
      if (selectedAPIKey) {
        this.props.updateAPIAccess(data, selectedAPIKey.uuid);
      } else {
        this.props.createAPIAccess(data);
      }
    }

    this.setState({ showModal: false, selectedAPIKey: null });
  };

  handleEditClick = (data) => {
    this.setState({ selectedAPIKey: data, showModal: true });
  };

  handleDeleteClick = (APIAccess) => {
    confirmDelete({
      onOk: () => {
        this.props.deleteAPIAccess(APIAccess?.uuid);
      },
    });
  };

  handleSearchQueryChange = (e) => {
    this.setState({ searchQuery: e.target.value });
  };

  handleCopyClick = (APIKey) => {
    navigator.clipboard.writeText(APIKey);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  };

  getColumns = () => {
    return [
      {
        title: <ColumnTitle columnName="Key Nickname" />,
        dataIndex: 'api_key_name',
        key: 'api_key_name',
        ellipsis: {
          showTitle: true,
        },
        render: (item) => (item ? item : 'no name set'),
      },
      {
        title: <ColumnTitle columnName="API Key" />,
        dataIndex: 'api_key',
        key: 'api_key',
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: <ColumnTitle columnName="Expires At" />,
        dataIndex: 'expires_at',
        key: 'expires_at',
      },
      {
        title: <ColumnTitle columnName="Created By" />,
        dataIndex: ['created_by', 'email'],
        key: 'created_by',
      },
      {
        title: <ColumnTitle columnName="Request Count" />,
        dataIndex: 'requests_count',
        key: 'requests_count',
      },
      {
        title: <ColumnTitle columnName="Actions" />,
        key: 'actions',
        render: (item) => (
          <div className={styles.action_buttons}>
            <CopyOutlined
              style={{
                fontSize: '20px',
                marginRight: '10px',
              }}
              onClick={() => this.handleCopyClick(item?.api_key)}
            />
            <EditOutlined
              style={{
                fontSize: '20px',
                marginRight: '10px',
              }}
              onClick={() => this.handleEditClick(item)}
            />
            <DeleteOutlined
              style={{
                fontSize: '20px',
              }}
              onClick={() => this.handleDeleteClick(item)}
            />
          </div>
        ),
      },
    ];
  };

  /*  getFilteredDepartments = () => {
    const { departments } = this.props;
    const { searchQuery } = this.state;
    const query = searchQuery.trim().toLowerCase();
    if (!query) return departments;
    return departments.filter((u) => u.name.toLowerCase().includes(query));
  };
*/

  render() {
    const { status, APIAccessData, subscriptionInfo } = this.props;
    const { showModal, selectedAPIKey } = this.state;
    const loading = status === STATUS.LOADING;
    const loaded = status === STATUS.LOADED;

    const APIAccessDataWithCorrectDates = APIAccessData.map((el) => {
      return {
        ...el,
        created_at: moment
          .utc(el.created_at)
          .format('YYYY-MM-DD HH:mm')
          .toString(),
        expires_at: moment
          .utc(el.expires_at)
          .format('YYYY-MM-DD HH:mm')
          .toString(),
      };
    });

    return (
      <div className={styles.container}>
        <DetailsModal
          show={showModal}
          onCancel={this.handleModalClose}
          onSubmit={this.handleSubmit}
          selectedAPIKey={selectedAPIKey}
        />
        <div className={styles.top_section}>
          <span style={{ float: 'left' }}>
            Daily Request Limit:{' '}
            {subscriptionInfo?.requests_limit !== null
              ? subscriptionInfo?.requests_limit
              : 'unlimited'}
          </span>
          <span style={{ float: 'left', marginLeft: '8px' }}>
            Daily Request Left:{' '}
            {subscriptionInfo?.total_requests_left !== null
              ? subscriptionInfo?.total_requests_left
              : 'unlimited'}
          </span>
          {/*<Input
            placeholder="Search Departments"
            prefix={<SearchOutlined />}
            className={styles.search_input}
            onChange={this.handleSearchQueryChange}
            value={searchQuery}
          />*/}
          <Button
            className={styles.add_new_button}
            type="primary"
            onClick={this.handleCreateClick}
          >
            + Add New API Key
          </Button>
        </div>
        {loaded && (
          <Table
            style={{ borderTop: '1px solid rgba(255, 255, 255, 0.3)' }}
            columns={this.getColumns()}
            dataSource={APIAccessDataWithCorrectDates}
            loading={loading}
            pagination={false}
          />
        )}
      </div>
    );
  }
}

export default APIAccessSettings;
